// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "component/board/v1/board.proto" (package "viam.component.board.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { GetGeometriesResponse } from "../../../common/v1/common";
import { GetGeometriesRequest } from "../../../common/v1/common";
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { DoCommandResponse } from "../../../common/v1/common";
import { DoCommandRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../google/protobuf/duration";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.component.board.v1.Status
 */
export interface Status {
    /**
     * @generated from protobuf field: map<string, int32> analogs = 1;
     */
    analogs: {
        [key: string]: number;
    };
    /**
     * @generated from protobuf field: map<string, int64> digital_interrupts = 2;
     */
    digitalInterrupts: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message viam.component.board.v1.SetGPIORequest
 */
export interface SetGPIORequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string pin = 2;
     */
    pin: string;
    /**
     * @generated from protobuf field: bool high = 3;
     */
    high: boolean;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.SetGPIOResponse
 */
export interface SetGPIOResponse {
}
/**
 * @generated from protobuf message viam.component.board.v1.GetGPIORequest
 */
export interface GetGPIORequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string pin = 2;
     */
    pin: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.GetGPIOResponse
 */
export interface GetGPIOResponse {
    /**
     * @generated from protobuf field: bool high = 1;
     */
    high: boolean;
}
/**
 * @generated from protobuf message viam.component.board.v1.PWMRequest
 */
export interface PWMRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string pin = 2;
     */
    pin: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.PWMResponse
 */
export interface PWMResponse {
    /**
     * @generated from protobuf field: double duty_cycle_pct = 1;
     */
    dutyCyclePct: number; // 0-1
}
/**
 * @generated from protobuf message viam.component.board.v1.SetPWMRequest
 */
export interface SetPWMRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string pin = 2;
     */
    pin: string;
    /**
     * @generated from protobuf field: double duty_cycle_pct = 3;
     */
    dutyCyclePct: number; // 0-1
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.SetPWMResponse
 */
export interface SetPWMResponse {
}
/**
 * @generated from protobuf message viam.component.board.v1.PWMFrequencyRequest
 */
export interface PWMFrequencyRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string pin = 2;
     */
    pin: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.PWMFrequencyResponse
 */
export interface PWMFrequencyResponse {
    /**
     * @generated from protobuf field: uint64 frequency_hz = 1;
     */
    frequencyHz: string;
}
/**
 * @generated from protobuf message viam.component.board.v1.SetPWMFrequencyRequest
 */
export interface SetPWMFrequencyRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string pin = 2;
     */
    pin: string;
    /**
     * @generated from protobuf field: uint64 frequency_hz = 3;
     */
    frequencyHz: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.SetPWMFrequencyResponse
 */
export interface SetPWMFrequencyResponse {
}
// Analog Reader

/**
 * @generated from protobuf message viam.component.board.v1.ReadAnalogReaderRequest
 */
export interface ReadAnalogReaderRequest {
    /**
     * @generated from protobuf field: string board_name = 1;
     */
    boardName: string;
    /**
     * @generated from protobuf field: string analog_reader_name = 2;
     */
    analogReaderName: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.ReadAnalogReaderResponse
 */
export interface ReadAnalogReaderResponse {
    /**
     * @generated from protobuf field: int32 value = 1;
     */
    value: number;
    /**
     * @generated from protobuf field: float min_range = 2;
     */
    minRange: number;
    /**
     * @generated from protobuf field: float max_range = 3;
     */
    maxRange: number;
    /**
     * @generated from protobuf field: float step_size = 4;
     */
    stepSize: number;
}
// Analog Writer

/**
 * @generated from protobuf message viam.component.board.v1.WriteAnalogRequest
 */
export interface WriteAnalogRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string pin = 2;
     */
    pin: string;
    /**
     * @generated from protobuf field: int32 value = 3;
     */
    value: number;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.WriteAnalogResponse
 */
export interface WriteAnalogResponse {
}
// Digital Interrupt

/**
 * @generated from protobuf message viam.component.board.v1.GetDigitalInterruptValueRequest
 */
export interface GetDigitalInterruptValueRequest {
    /**
     * @generated from protobuf field: string board_name = 1;
     */
    boardName: string;
    /**
     * @generated from protobuf field: string digital_interrupt_name = 2;
     */
    digitalInterruptName: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.GetDigitalInterruptValueResponse
 */
export interface GetDigitalInterruptValueResponse {
    /**
     * @generated from protobuf field: int64 value = 1;
     */
    value: string;
}
/**
 * @generated from protobuf message viam.component.board.v1.StreamTicksRequest
 */
export interface StreamTicksRequest {
    /**
     * Board name
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Name of digital interrupts to recieve ticks from
     *
     * @generated from protobuf field: repeated string pin_names = 2;
     */
    pinNames: string[];
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.StreamTicksResponse
 */
export interface StreamTicksResponse {
    /**
     * name of interrupt
     *
     * @generated from protobuf field: string pin_name = 1;
     */
    pinName: string;
    /**
     * Time in nanoseconds of a tick
     *
     * @generated from protobuf field: uint64 time = 2;
     */
    time: string;
    /**
     * Value high or low of the tick
     *
     * @generated from protobuf field: bool high = 3;
     */
    high: boolean;
}
/**
 * @generated from protobuf message viam.component.board.v1.SetPowerModeRequest
 */
export interface SetPowerModeRequest {
    /**
     * name of board
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Requested power mode
     *
     * @generated from protobuf field: viam.component.board.v1.PowerMode power_mode = 2;
     */
    powerMode: PowerMode;
    /**
     * Requested duration to stay in `power_mode`
     *
     * @generated from protobuf field: optional google.protobuf.Duration duration = 3;
     */
    duration?: Duration;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.board.v1.SetPowerModeResponse
 */
export interface SetPowerModeResponse {
}
// Power Management API

/**
 * @generated from protobuf enum viam.component.board.v1.PowerMode
 */
export enum PowerMode {
    /**
     * @generated from protobuf enum value: POWER_MODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: POWER_MODE_NORMAL = 1;
     */
    NORMAL = 1,
    /**
     * @generated from protobuf enum value: POWER_MODE_OFFLINE_DEEP = 2;
     */
    OFFLINE_DEEP = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class Status$Type extends MessageType<Status> {
    constructor() {
        super("viam.component.board.v1.Status", [
            { no: 1, name: "analogs", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } },
            { no: 2, name: "digital_interrupts", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 3 /*ScalarType.INT64*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.Status
 */
export const Status = new Status$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGPIORequest$Type extends MessageType<SetGPIORequest> {
    constructor() {
        super("viam.component.board.v1.SetGPIORequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "high", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.SetGPIORequest
 */
export const SetGPIORequest = new SetGPIORequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGPIOResponse$Type extends MessageType<SetGPIOResponse> {
    constructor() {
        super("viam.component.board.v1.SetGPIOResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.SetGPIOResponse
 */
export const SetGPIOResponse = new SetGPIOResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGPIORequest$Type extends MessageType<GetGPIORequest> {
    constructor() {
        super("viam.component.board.v1.GetGPIORequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.GetGPIORequest
 */
export const GetGPIORequest = new GetGPIORequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGPIOResponse$Type extends MessageType<GetGPIOResponse> {
    constructor() {
        super("viam.component.board.v1.GetGPIOResponse", [
            { no: 1, name: "high", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.GetGPIOResponse
 */
export const GetGPIOResponse = new GetGPIOResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PWMRequest$Type extends MessageType<PWMRequest> {
    constructor() {
        super("viam.component.board.v1.PWMRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.PWMRequest
 */
export const PWMRequest = new PWMRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PWMResponse$Type extends MessageType<PWMResponse> {
    constructor() {
        super("viam.component.board.v1.PWMResponse", [
            { no: 1, name: "duty_cycle_pct", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.PWMResponse
 */
export const PWMResponse = new PWMResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPWMRequest$Type extends MessageType<SetPWMRequest> {
    constructor() {
        super("viam.component.board.v1.SetPWMRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "duty_cycle_pct", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.SetPWMRequest
 */
export const SetPWMRequest = new SetPWMRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPWMResponse$Type extends MessageType<SetPWMResponse> {
    constructor() {
        super("viam.component.board.v1.SetPWMResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.SetPWMResponse
 */
export const SetPWMResponse = new SetPWMResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PWMFrequencyRequest$Type extends MessageType<PWMFrequencyRequest> {
    constructor() {
        super("viam.component.board.v1.PWMFrequencyRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.PWMFrequencyRequest
 */
export const PWMFrequencyRequest = new PWMFrequencyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PWMFrequencyResponse$Type extends MessageType<PWMFrequencyResponse> {
    constructor() {
        super("viam.component.board.v1.PWMFrequencyResponse", [
            { no: 1, name: "frequency_hz", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.PWMFrequencyResponse
 */
export const PWMFrequencyResponse = new PWMFrequencyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPWMFrequencyRequest$Type extends MessageType<SetPWMFrequencyRequest> {
    constructor() {
        super("viam.component.board.v1.SetPWMFrequencyRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "frequency_hz", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.SetPWMFrequencyRequest
 */
export const SetPWMFrequencyRequest = new SetPWMFrequencyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPWMFrequencyResponse$Type extends MessageType<SetPWMFrequencyResponse> {
    constructor() {
        super("viam.component.board.v1.SetPWMFrequencyResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.SetPWMFrequencyResponse
 */
export const SetPWMFrequencyResponse = new SetPWMFrequencyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadAnalogReaderRequest$Type extends MessageType<ReadAnalogReaderRequest> {
    constructor() {
        super("viam.component.board.v1.ReadAnalogReaderRequest", [
            { no: 1, name: "board_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "analog_reader_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.ReadAnalogReaderRequest
 */
export const ReadAnalogReaderRequest = new ReadAnalogReaderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadAnalogReaderResponse$Type extends MessageType<ReadAnalogReaderResponse> {
    constructor() {
        super("viam.component.board.v1.ReadAnalogReaderResponse", [
            { no: 1, name: "value", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "min_range", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "max_range", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "step_size", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.ReadAnalogReaderResponse
 */
export const ReadAnalogReaderResponse = new ReadAnalogReaderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WriteAnalogRequest$Type extends MessageType<WriteAnalogRequest> {
    constructor() {
        super("viam.component.board.v1.WriteAnalogRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.WriteAnalogRequest
 */
export const WriteAnalogRequest = new WriteAnalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WriteAnalogResponse$Type extends MessageType<WriteAnalogResponse> {
    constructor() {
        super("viam.component.board.v1.WriteAnalogResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.WriteAnalogResponse
 */
export const WriteAnalogResponse = new WriteAnalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDigitalInterruptValueRequest$Type extends MessageType<GetDigitalInterruptValueRequest> {
    constructor() {
        super("viam.component.board.v1.GetDigitalInterruptValueRequest", [
            { no: 1, name: "board_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "digital_interrupt_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.GetDigitalInterruptValueRequest
 */
export const GetDigitalInterruptValueRequest = new GetDigitalInterruptValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDigitalInterruptValueResponse$Type extends MessageType<GetDigitalInterruptValueResponse> {
    constructor() {
        super("viam.component.board.v1.GetDigitalInterruptValueResponse", [
            { no: 1, name: "value", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.GetDigitalInterruptValueResponse
 */
export const GetDigitalInterruptValueResponse = new GetDigitalInterruptValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamTicksRequest$Type extends MessageType<StreamTicksRequest> {
    constructor() {
        super("viam.component.board.v1.StreamTicksRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pin_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.StreamTicksRequest
 */
export const StreamTicksRequest = new StreamTicksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamTicksResponse$Type extends MessageType<StreamTicksResponse> {
    constructor() {
        super("viam.component.board.v1.StreamTicksResponse", [
            { no: 1, name: "pin_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "time", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 3, name: "high", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.StreamTicksResponse
 */
export const StreamTicksResponse = new StreamTicksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPowerModeRequest$Type extends MessageType<SetPowerModeRequest> {
    constructor() {
        super("viam.component.board.v1.SetPowerModeRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "power_mode", kind: "enum", T: () => ["viam.component.board.v1.PowerMode", PowerMode, "POWER_MODE_"] },
            { no: 3, name: "duration", kind: "message", T: () => Duration },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.SetPowerModeRequest
 */
export const SetPowerModeRequest = new SetPowerModeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPowerModeResponse$Type extends MessageType<SetPowerModeResponse> {
    constructor() {
        super("viam.component.board.v1.SetPowerModeResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.board.v1.SetPowerModeResponse
 */
export const SetPowerModeResponse = new SetPowerModeResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.component.board.v1.BoardService
 */
export const BoardService = new ServiceType("viam.component.board.v1.BoardService", [
    { name: "SetGPIO", options: { "google.api.http": { put: "/viam/api/v1/component/board/{name}/gpio" } }, I: SetGPIORequest, O: SetGPIOResponse },
    { name: "GetGPIO", options: { "google.api.http": { get: "/viam/api/v1/component/board/{name}/gpio" } }, I: GetGPIORequest, O: GetGPIOResponse },
    { name: "PWM", options: { "google.api.http": { get: "/viam/api/v1/component/board/{name}/pwm" } }, I: PWMRequest, O: PWMResponse },
    { name: "SetPWM", options: { "google.api.http": { put: "/viam/api/v1/component/board/{name}/pwm" } }, I: SetPWMRequest, O: SetPWMResponse },
    { name: "PWMFrequency", options: { "google.api.http": { get: "/viam/api/v1/component/board/{name}/pwm_freq" } }, I: PWMFrequencyRequest, O: PWMFrequencyResponse },
    { name: "SetPWMFrequency", options: { "google.api.http": { put: "/viam/api/v1/component/board/{name}/pwm_freq" } }, I: SetPWMFrequencyRequest, O: SetPWMFrequencyResponse },
    { name: "DoCommand", options: { "google.api.http": { post: "/viam/api/v1/component/board/{name}/do_command" } }, I: DoCommandRequest, O: DoCommandResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/component/board/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse },
    { name: "ReadAnalogReader", options: { "google.api.http": { get: "/viam/api/v1/component/board/{board_name}/analog_reader/{analog_reader_name}/read" } }, I: ReadAnalogReaderRequest, O: ReadAnalogReaderResponse },
    { name: "WriteAnalog", options: { "google.api.http": { put: "/viam/api/v1/component/board/{name}/analog_write" } }, I: WriteAnalogRequest, O: WriteAnalogResponse },
    { name: "GetDigitalInterruptValue", options: { "google.api.http": { get: "/viam/api/v1/component/board/{board_name}/digital_interrupt/{digital_interrupt_name}/value" } }, I: GetDigitalInterruptValueRequest, O: GetDigitalInterruptValueResponse },
    { name: "StreamTicks", serverStreaming: true, options: { "google.api.http": { get: "/viam/api/v1/component/board/{name}/tick_stream" } }, I: StreamTicksRequest, O: StreamTicksResponse },
    { name: "SetPowerMode", options: { "google.api.http": { put: "/viam/api/v1/component/board/{name}/power_mode" } }, I: SetPowerModeRequest, O: SetPowerModeResponse },
    { name: "GetGeometries", options: { "google.api.http": { get: "/viam/api/v1/component/board/{name}/geometries" } }, I: GetGeometriesRequest, O: GetGeometriesResponse }
]);
